import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=03a2f58d"
import script from "./Posts.vue?vue&type=script&lang=ts"
export * from "./Posts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports